import { GENERAL_HP_ROLE_LIST } from 'clickNgo/entities/contact'

export const getContactRolesToReassign = (roles: string[]) => {
  return roles.filter((role) => GENERAL_HP_ROLE_LIST.includes(role)).map((role) => ({ role }))
}
